import React from 'react';
import { Box, Dialog, Typography } from '@mui/material';
import InfoRoundedIcon from '@mui/icons-material/InfoRounded';
import { useModal } from '../../../../../store/ModalProvider';
import CustomButton from '../../CustomButton/CustomButton';
import type { StatusMessageModalData } from '../../../../../types/modal';

const CustomModalInfoMessage: React.FC = () => {
  const { isOpen, closeModal, modalData, modalHandlers } = useModal();
  const infoData = modalData as StatusMessageModalData | undefined;
  const [handleNext] = modalHandlers ?? [];

  if (!infoData) {
    return null;
  }

  const message = infoData.message ?? '< Mensagem Informativa >';
  const primaryLabel = infoData.primaryLabel ?? 'Ok';
  const secondaryLabel = infoData.secondaryLabel ?? 'lorem ipsum';

  const handleAdvance = () => {
    if (typeof handleNext === 'function') {
      handleNext(infoData);
      return;
    }
    closeModal();
  };

  return (
    <Dialog
      open={isOpen}
      onClose={handleAdvance}
      sx={{ pointerEvents: 'auto', zIndex: 2000 }}
      PaperProps={{
        sx: {
          width: 'min(444px, 100%)',
          borderRadius: '4px',
          backgroundColor: '#FFFFFF',
          boxShadow:
            '0 6px 30px 5px rgba(9, 32, 86, 0.12), 0 16px 24px 2px rgba(9, 32, 86, 0.14), 0 8px 10px -5px rgba(9, 32, 86, 0.2)',
          overflow: 'hidden',
          zIndex: 2001,
        },
      }}
    >
      <Box
        sx={{
          background:
            'linear-gradient(180deg, rgba(0, 165, 255, 0.1) 0%, rgba(0, 165, 255, 0) 100%)',
          paddingTop: '16px',
        }}
      >
        <Box sx={{ display: 'flex', justifyContent: 'center' }}>
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              padding: '16px',
              borderRadius: '999px',
              background: 'linear-gradient(90deg, #00A5FF 0%, #37CDFF 100%)',
            }}
          >
            <InfoRoundedIcon sx={{ fontSize: 35, color: '#FFFFFF' }} />
          </Box>
        </Box>
        <Box sx={{ padding: '16px 24px' }}>
          <Typography
            sx={{
              fontFamily: 'Poppins, sans-serif',
              fontSize: '16px',
              fontWeight: 600,
              lineHeight: 1.75,
              letterSpacing: '0.15px',
              color: '#092056',
            }}
          >
            {message}
          </Typography>
        </Box>
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'flex-end',
            gap: '8px',
            padding: '8px',
          }}
        >
          <CustomButton
            variant="text"
            color="primary"
            onClick={handleAdvance}
            sx={{
              padding: '6px 8px',
              borderRadius: '4px',
              fontSize: '14px',
              fontWeight: 600,
              lineHeight: '24px',
              textTransform: 'none',
              color: '#00A5FF',
            }}
          >
            {secondaryLabel}
          </CustomButton>
          <CustomButton
            variant="contained"
            onClick={handleAdvance}
            sx={{
              padding: '6px 16px',
              borderRadius: '4px',
              fontSize: '14px',
              fontWeight: 600,
              lineHeight: '24px',
              textTransform: 'none',
              background: '#092056',
              color: '#FFFFFF',
              '&:hover': {
                background: '#08204F',
              },
            }}
          >
            {primaryLabel}
          </CustomButton>
        </Box>
      </Box>
    </Dialog>
  );
};

export default CustomModalInfoMessage;
